<script setup>
import {useRouting} from "@/composables/routing.js";
const {href, url} = useRouting();

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <title>Impressum</title>
        <meta name="description" content="Impressum der LAY7 cloud">
        <link rel="canonical" :href="url('/legal/imprint', 'de')">
        <link rel="alternate" hreflang="en" :href="url('/legal/imprint', 'en')">
        <link rel="alternate" hreflang="de" :href="url('/legal/imprint', 'de')">
        <meta name="robots" content="noindex, nofollow">
    </Head>
    <section>
        <div class="container px-4 mx-auto mt-28 lg:mt-36">
            <h1 class="font-semibold text-4xl text-black space-x-3 mb-3">
                Impressum
            </h1>
            <p>
                Angaben gemäß §5 TMG
            </p>
            <p class="mt-2">
                <br>
                Tobias Holst e.K
                <br>
                Richard-Strauss-Str. 13
                <br>
                81677 München
                <br>
                GERMANY
            </p>
        </div>
    </section>

    <section class="mt-8 lg:mt-12">
        <div class="container px-4 mx-auto">
            <h2 class="font-semibold text-3xl text-black space-x-3 mb-5">
                Kontakt
            </h2>
            <p class="mt-2">
                Telefon: +49 89 339 80 65 0
                <br>
                Telefax: +49 89 339 80 65 99
                <br>
                E-Mail: support@lay7.cloud
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Umsatzsteuer-ID gemäß §27a Umsatzsteuergesetz:
            </p>
            <p>
                DE 299 09 12 83
            </p>
            <p class="text-gray-500 mt-4">
                Quelle: http://www.e-recht24.de
            </p>
        </div>
    </section>

    <section class="mt-8 lg:mt-12">
        <div class="container px-4 mx-auto">
            <h2 class="font-semibold text-3xl text-black space-x-3 mb-5">
                Haftungsausschluss (Disclaimer)
            </h2>
            <p class="mt-4 text-black text-lg font-bold">
                Haftung für Inhalte
            </p>
            <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Haftung für Links
            </p>
            <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Urheberrecht
            </p>
            <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
        </div>
    </section>
</template>
